import {
  FacadeFormFieldSubmissionBody,
  ProgramRegistrant,
  Registration,
} from '@la/types';
import baseApi from './baseApi';
import { Tournament } from './types/tournament';

export const tournamentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTournament: builder.query<
      Tournament,
      {
        siteDomain: string;
        tournamentId: string;
      }
    >({
      query: ({ siteDomain, tournamentId }) => {
        return {
          url: `/api/member-portal/${siteDomain}/tournaments/${tournamentId}`,
          method: 'GET',
        };
      },
    }),
    getTournamentRegistration: builder.query<
      Tournament,
      {
        siteDomain: string;
        tournamentId: string;
      }
    >({
      query: ({ siteDomain, tournamentId }) => {
        return {
          url: `/api/member-portal/${siteDomain}/tournaments/${tournamentId}/registration`,
          method: 'GET',
        };
      },
      providesTags: ['Registration'],
    }),
    getTournamentRegistrant: builder.query<
      ProgramRegistrant,
      {
        siteDomain: string;
        tournamentId: string;
      }
    >({
      query: ({ siteDomain, tournamentId }) => {
        return {
          url: `/api/member-portal/${siteDomain}/tournaments/${tournamentId}/registrant`,
          method: 'GET',
        };
      },
    }),
    getUserRegistrations: builder.query<
      { userRegistrations: Registration[] },
      {
        programId: string;
        siteDomain: string;
      }
    >({
      query: ({ programId, siteDomain }) => {
        return {
          url: `/api/member-portal/${siteDomain}/registration?programId=${programId}`,
          method: 'GET',
        };
      },
      providesTags: ['Registration'],
    }),
    updateFormFieldsValues: builder.mutation<
      void,
      {
        siteDomain: string;
        payload: FacadeFormFieldSubmissionBody[];
      }
    >({
      query: ({ siteDomain, payload }) => ({
        url: `/api/member-portal/${siteDomain}/tournaments/form-fields`,
        method: 'POST',
        body: { facadeFormFields: payload },
      }),
    }),
  }),
});

export const {
  useGetTournamentQuery,
  useGetTournamentRegistrationQuery,
  useGetUserRegistrationsQuery,
  useGetTournamentRegistrantQuery,
  useUpdateFormFieldsValuesMutation,
} = tournamentApi;
